// extracted by mini-css-extract-plugin
export var activeCourseTab = "MapMarker-module--activeCourseTab--c6170";
export var courseTab = "MapMarker-module--courseTab--0e186";
export var sectorImg = "MapMarker-module--sectorImg--0332d";